var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocumentDark(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.788,
    height: 33.855,
    viewBox: "0 0 25.788 33.855",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-61)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.976,33.855H83.813a2.979,2.979,0,0,0,2.976-2.976V9.918H79.845A2.979,2.979,0,0,1,76.87,6.943V0H63.976A2.979,2.979,0,0,0,61,2.976v27.9A2.979,2.979,0,0,0,63.976,33.855Zm3.967-19.9h11.9a.992.992,0,0,1,0,1.984h-11.9a.992.992,0,1,1,0-1.984Zm0,3.967h11.9a.992.992,0,0,1,0,1.984h-11.9a.992.992,0,1,1,0-1.984Zm0,3.967h11.9a.992.992,0,0,1,0,1.984h-11.9a.992.992,0,1,1,0-1.984Zm0,3.967h7.935a.992.992,0,1,1,0,1.984H67.943a.992.992,0,1,1,0-1.984Z",
    fill: "#0086cc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.992,16.143h6.362L331,8.789v6.362A.993.993,0,0,0,331.992,16.143Z",
    transform: "translate(-252.147 -8.208)",
    fill: "#0086cc"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentDark);
export default __webpack_public_path__ + "static/media/document-dark.155ef71b81ab346d2fb8a2ed0ee0e837.svg";
export { ForwardRef as ReactComponent };